import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { PricingCard } from './PricingCard';
import { UrgencyBlock } from './UrgencyBlock';
export function Pricing() {
  return <section id="precio" className="scroll-mt-4 bg-canvas py-14" data-id="element-133" data-mp="2oiftxcrg0yas">
      <div className="mx-auto max-w-page px-5" data-id="element-134" data-mp="2ohxrtzi3npuy">
        <SectionHeading eyebrow="Tu inversión" title="Todo el sistema, un solo pago" subtitle="Sin suscripción, sin cuotas escondidas y sin un segundo producto que te vendan después." data-id="element-135" data-mp="2jj4cs2n5zqso" />

        <div className="mt-8" data-id="element-136" data-mp="1rsq2eged0wlr">
          <UrgencyBlock data-id="element-137" data-mp="1rthvnkkhii8v" />
        </div>

        <div className="mt-5" data-id="element-138" data-mp="1rut1rr1ek235">
          <PricingCard data-id="element-139" data-mp="25sr2htmsw006" />
        </div>
      </div>
    </section>;
}